import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DataService } from 'src/app/data.service';

interface NavTechnicalUserSettings {
  login: string;
  password: string;
  taxnumber: string;
  signkey: string;
  exchangekey: string;
}

interface NavSoftwareSettings {
  softwareId: string;
  softwareName: string;
  softwareOperation: string;
  softwareMainVersion: string;
  softwareDevName: string;
  softwareDevContact: string;
  softwareDevCountryCode: string;
  softwareDevTaxNumber: string;
}

interface NavSettings {
  intezmeny: string;
  sandbox_enabled: boolean;
  nav_enabled: boolean;
  live: NavTechnicalUserSettings;
  test: NavTechnicalUserSettings;
  software: NavSoftwareSettings;
}

@Component({
  selector: 'app-nav',
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.scss'],
})
export class NavComponent implements OnInit {
  loading = false;
  saving = false;
  sajatIntezmeny: any;
  navdata: NavSettings = this.emptySettings();

  constructor(private http: HttpClient, private data: DataService) { }

  async ngOnInit() {
    this.sajatIntezmeny = await this.data.getFromStorage('sajatIntezmeny');
    this.loadNav();
  }

  loadNav() {
    if (!this.sajatIntezmeny?.intezmenyId) return;

    this.loading = true;
    this.data.getNav(this.intezmenyPath()).subscribe({
      next: (response) => {
        this.navdata = this.normalizeSettings(response?.[0] || {});
        this.loading = false;
      },
      error: (error) => {
        console.error('NAV beállítás betöltési hiba:', error);
        this.loading = false;
        this.data.sendToast('Nem sikerült betölteni a NAV beállításokat.', 'error');
      },
    });
  }

  saveNav() {
    if (!this.sajatIntezmeny?.intezmenyId) return;

    this.saving = true;
    this.http.put<NavSettings>('/api/nyilvantartas/nav/' + this.intezmenyPath(), this.navdata).subscribe({
      next: (response) => {
        this.navdata = this.normalizeSettings(response || {});
        this.saving = false;
        this.data.sendToast('A NAV adatkapcsolat beállításai mentve.', 'success');
      },
      error: (error) => {
        console.error('NAV beállítás mentési hiba:', error);
        this.saving = false;
        this.data.sendToast('Nem sikerült menteni a NAV beállításokat.', 'error');
      },
    });
  }

  private intezmenyPath(): string {
    return String(this.sajatIntezmeny?.intezmenyId || '').replace(/^\/+|\/+$/g, '');
  }

  private emptyTechnicalUser(): NavTechnicalUserSettings {
    return {
      login: '',
      password: '',
      taxnumber: '',
      signkey: '',
      exchangekey: '',
    };
  }

  private emptySettings(): NavSettings {
    return {
      intezmeny: '',
      sandbox_enabled: false,
      nav_enabled: true,
      live: this.emptyTechnicalUser(),
      test: this.emptyTechnicalUser(),
      software: {
        softwareId: 'SULINFORM020250214',
        softwareName: 'SULINFORM',
        softwareOperation: 'ONLINE_SERVICE',
        softwareMainVersion: '2.1.2',
        softwareDevName: 'BLAHA-KER Bt.',
        softwareDevContact: 'info@blaha-ker.hu',
        softwareDevCountryCode: 'HU',
        softwareDevTaxNumber: '24556763',
      },
    };
  }

  private normalizeSettings(value: any): NavSettings {
    const defaults = this.emptySettings();
    return {
      ...defaults,
      ...value,
      sandbox_enabled: !!value?.sandbox_enabled,
      nav_enabled: value?.nav_enabled === undefined ? true : !!value?.nav_enabled,
      live: {
        ...defaults.live,
        ...(value?.live || {
          login: value?.login,
          password: value?.password,
          taxnumber: value?.taxnumber,
          signkey: value?.signkey,
          exchangekey: value?.exchangekey,
        }),
      },
      test: {
        ...defaults.test,
        ...(value?.test || {}),
      },
      software: {
        ...defaults.software,
        ...(value?.software || {}),
      },
    };
  }
}
